app.filter('reverse', function () {
    return function (input) {
        if (typeof input === 'undefined') {
            return;
        }
        else {
            return angular.isArray(input) ? input.slice().reverse() : (input + '').split('').reverse().join('');
        }
    };
});